import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import * as moment from 'moment';

@Component({
  selector: 'app-thankyoupage',
  templateUrl: './thankyoupage.component.html',
  styleUrls: ['./thankyoupage.component.scss']
})
export class ThankyoupageComponent implements OnInit, AfterViewInit {


  public accepted: boolean;
  public statusCobro: string;
  public unitPay: any;
  public urlParameters: any;
  public dateBegin: any;
  public dateBeginObj: any;
  public dateEnd: any;
  public dateEndObj: any;
  public arrayPassengersName: any;
  public arrayPassengersLastName: any;
  public tipoDestino: any;
  public tipoPlan: any;

  constructor(private elementRef: ElementRef, private _router: Router, private _route: ActivatedRoute) {

    /* obtencion de los parámetros de la url */
    this._route.queryParams.subscribe(params => {
      this.urlParameters = params;
    });

    // formato fechas
    moment.locale('es');
    this.dateBeginObj = (moment(this.urlParameters.dateFrom, 'DD/MM/YYYY')).toDate()
    this.dateBegin = moment(this.dateBeginObj).format('DD MMM'); 
    this.dateEndObj = (moment(this.urlParameters.dateTo, 'DD/MM/YYYY')).toDate()
    this.dateEnd = moment(this.dateEndObj).format('DD MMM'); 

    // console.log('urlParams 1-->', this.urlParameters);
    // console.log('urlParams 2-->', Array.isArray(this.urlParameters.passName));

    // crea los arrays
    if ( !Array.isArray(this.urlParameters.passName) ) {
      this.arrayPassengersName = [this.urlParameters.passName];
      this.arrayPassengersLastName = [this.urlParameters.passLastName];
    } else {
      this.arrayPassengersName = this.urlParameters.passName;
      this.arrayPassengersLastName = this.urlParameters.passLastName;
    }
    

    if (this.urlParameters.errorPNR === 'exitoso') {
      this.accepted = true;
      this.statusCobro = 'cobro exitoso';
    } else if (this.urlParameters.errorPNR === 'Declinado') {
      this.accepted = false;
      this.statusCobro = 'cobro rechazado';
    } else if (this.urlParameters.errorPNR === 'Pendiente') {
      this.accepted = false;
      this.statusCobro = 'cobro rechazado';
    } else if (this.urlParameters.errorPNR === 'Rechazado') {
      this.accepted = false;
      this.statusCobro = 'cobro rechazado';
    } else {
      this.accepted = false;
      this.statusCobro = 'cobro rechazado';
    }

    this.tipoDestino = this.urlParameters.tipoDestino;
    console.log('this.tipoDestino', this.tipoDestino);
    
    if (this.tipoDestino === '1' ) {
      this.tipoPlan = 'Nacional';
    } else if ( this.tipoDestino === '2' ) {
      this.tipoPlan = 'Internacional';
    }



    // pago por persona
    if (this.urlParameters.noPassengers === '1') {
      this.unitPay = (parseFloat(this.urlParameters.total)).toFixed(2);
    } else {
      this.unitPay = (parseFloat(this.urlParameters.total) / parseFloat(this.urlParameters.passName.length)).toFixed(2);
    }
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#E5E5E5';
  }

}